// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.thumbnail-wrapper img[data-v-64597512] {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n}\n.thumbnail-wrapper.selected[data-v-64597512] {\n  transform: scale(1.1);\n}\n.thumbnail-wrapper[data-v-64597512]:hover {\n  transform: scale(1.1);\n}\n", ""]);
// Exports
module.exports = exports;
